/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Text } from '@chakra-ui/react';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactExport from 'react-export-excel';
import { useTranslation } from 'react-i18next';
import c from '../../../constant';
import { fileNameEWS } from '../Miscellaneous/export';
import useStore from '../../../store';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { getYear } from '../../../containers/EarlyWarning/utils';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function AnnuallyExcelSummarizedReportSFP({ object = null, ...props }) {
	const { t } = useTranslation();
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const reportId = urlParams.get('reportId') ?? null;
	const years = urlParams.get('years') ?? null;
	const currentLang = useStore((state) => state.currentLang);

	const tables = object?.tables || [];
	const labels = object?.labels || [];

	const showYear = (() => {
		if (!years) return `${getYear(null)}`;

		let parsed;

		try {
			parsed = JSON.parse(years);
		} catch (e) {
			return `${getYear(null)}`;
		}

		if (!Array.isArray(parsed)) {
			return `${getYear(parsed)}`;
		}

		const ys = parsed
			.map((s) => parseInt(s))
			.sort((a, b) => a - b)
			.map((p) => getYear(p));

		return ys.join('-');
	})();

	const data = useMemo(() => {
		if (!labels.length || !tables.length) return [];

		return labels.map((label, rowIdx) => {
			const row = {
				title: currentLang === 'kh' ? label?.titleKhmer : label?.titleEnglish,
			};

			tables.forEach((table) => {
				const year = table?.key;
				row[`${year}_USD`] = table?.tableCells?.[rowIdx]?.[0]?.value ?? '';
				row[`${year}_KHR000`] = table?.tableCells?.[rowIdx]?.[1]?.value ?? '';
			});

			return row;
		});
	}, [labels, tables, currentLang]);

	return (
		<Box {...props}>
			<ExcelFile
				filename={fileNameEWS(
					reportId === 'annually_audited_financial_statements'
						? `Annually Audited Financial Summarized Report_${showYear}`
						: reportId === 'annually_unaudited_financial_statements'
							? `Annually Unaudited Financial Summarized Report_${showYear}`
							: null,
					null,
					null,
				)}
				element={
					<Button
						leftIcon={<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16 }} />}
						colorScheme="gray"
						variant="solid"
						size="sm"
						borderRadius={c.borderRadius}
						border="1px solid #bdc3c7"
					>
						{t('Export')}
					</Button>
				}
			>
				<ExcelSheet data={data} name="SFP">
					<ExcelColumn label={t('Label')} value="title" />

					{tables?.map((shownQuarter) => {
						const quarter = shownQuarter?.key;
						return [
							<ExcelColumn label={`${quarter}_USD`} value={`${quarter}_USD`} />,
							<ExcelColumn label={`${quarter}_KHR'000`} value={`${quarter}_KHR000`} />,
						];
					})}
				</ExcelSheet>
			</ExcelFile>
		</Box>
	);
}
